import { useEffect, useMemo } from 'react'

import config from '@app/config'
import {
  identifyUserInHubspot,
  launchHubSpotChat,
} from '@app/services/tracking/events'
import { hasPermission, UserPermission } from '@app/store/user'

import { isB2BView } from '@app/utils'
import { isImpersonatedB2BSession } from '@app/utils/token/isImpersonatedB2BSession'

import { useIsStaff } from './user/useHasRole'
import { useUser } from './user/useUser'

export const useHubSpot = () => {
  const userState = useUser()
  const isStaff = useIsStaff()

  const hasHubSpotAccess = useMemo(() => {
    if (
      !isB2BView() ||
      isImpersonatedB2BSession() ||
      config.identity.isWebView
    ) {
      return false
    }
    if (
      (userState.currentUser && isStaff) ||
      !hasPermission(userState)(UserPermission.AccountsShowChat)
    ) {
      return false
    }
    return true
  }, [isStaff, userState.currentUser?.id])

  const shoulIdentifyUser = useMemo(() => {
    return (
      hasPermission(userState)(UserPermission.AccountsHasHubSpotSync) ||
      !isB2BView()
    )
  }, [userState.currentUser?.id])

  useEffect(() => {
    if (shoulIdentifyUser) {
      identifyUserInHubspot()
    }
    if (hasHubSpotAccess) {
      launchHubSpotChat()
    }
  }, [hasHubSpotAccess, shoulIdentifyUser])
}
